<template>
    <div class="RatingStars">
        <span
            v-for="star in stars"
            :key="star"
            class="star fa"
            :class="[starClass(star), disabled ? 'disabled' : '']"
            @click="select(star)"
        ></span>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.RatingStars .star {
    &:not(.disabled) {
        cursor: pointer;
    }
}

.RatingStars .star.--full,
.RatingStars .star.--half {
    @apply text-yellow-500;
    /*color: #ffd147;*/
}

.RatingStars .star.--empty {
    @apply text-gray-400;
    /*color: gray;*/
}
</style>

<script type="text/babel">
import collect from 'collect.js'

export default {
    props: ['value', 'disabled'],

    data() {
        return {
            stars: collect()
                .times(5, number => number)
                .toArray(),
        }
    },

    methods: {
        starClass(star) {
            if (this.value >= star) return 'fa-star --full'

            if (this.value > star - 1 && this.value < star) return 'fa-star-half-o --half'

            return 'fa-star --empty'
        },

        select(star) {
            if (!this.disabled) {
                this.$emit('input', star)
            }
        },
    },
}
</script>
